import * as types from '../types/triage';
import { getTriage } from '../../services/diagnosisLogic/triageLogic';

export const triageFetchRequested = () => ({
  type: types.TRIAGE_FETCH_REQUESTED
});

export const triageFetchSuccess = ({ data }) => ({
  data,
  type: types.TRIAGE_FETCH_SUCCESS
});

export function fetchTriage(data) {
  return dispatch => {
    dispatch(triageFetchRequested());
    const result = getTriage(data);
    dispatch(triageFetchSuccess({ data: result }));
  };
}
